module.exports = __webpack_public_path__ + "img/icone_banco_dados_branco.89322369.svg";